export default "<p>entry-point works!</p>\r\n"